import axios from "axios";

let timeoutCallbacks = null;

export const setTimeoutResetCallback = (callbacks) => {
    timeoutCallbacks = callbacks;
};


axios.interceptors.request.use(
    config => {
        // Pause session timeout during API calls
        if (timeoutCallbacks?.pauseTimeout) {
            timeoutCallbacks.pauseTimeout();
        }

        const token = sessionStorage.getItem('Token');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        Promise.reject(new Error(error));
    }
);


axios.interceptors.response.use((response) => { // block to handle success case
    // Resume session timeout after API completes
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    // Handle force logout success
    if (response.config.url && response.config.url.includes('/force-logout/')) {
        const message = response.data?.message || 'All active sessions have been terminated.';
        console.log('Force logout successful:', message);
    }
    
    return response;
}, function (error) { // block to handle error case
    // Resume session timeout after API error
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    
    // Handle 401 Unauthorized - token may be blacklisted or expired
    if (error?.response?.status === 401) {
        const errorMessage = error?.response?.data?.message || '';
        
        // Clear session data
        sessionStorage.clear();
        
        // Show appropriate message based on error type
        if (errorMessage.includes('revoked') || errorMessage.includes('blacklisted')) {
            alert('Your session has been terminated because you logged in from another device/browser. Please login again.');
        } else if (errorMessage.includes('expired')) {
            alert('Your session has expired. Please login again.');
        } else if (errorMessage.includes('invalid token') || errorMessage.includes('Access denied')) {
            alert('Invalid authentication token. Please login again.');
        } else {
            alert('Authentication failed. Please login again.');
        }
        
        // Redirect to login
        window.location.href = '/';
        return Promise.reject('Authentication failed');
    }
    
    // Handle 403 Forbidden - insufficient permissions
    if (error?.response?.status === 403) {
        alert('You do not have permission to access this resource. Please contact your administrator.');
        return Promise.reject(error.response.data);
    }
    
    console.log("error", error);
    if (error?.response?.data) {
        return Promise.reject(error.response.data);
    }

    return Promise.reject("Unable to process request");
});
